module.exports = __webpack_public_path__ + "static/media/sauce_dashboard.807d98e5.png";